import type { MouseEvent } from 'react'

import type { NavigateFunction, NavigateOptions } from 'react-router'

/**
 * 通常クリックなら navigate し、cmd(Mac) / ctrl(Windows)+クリックなら新規タブで開く。
 * onClick ハンドラ等で発生した MouseEvent を受け取り、修飾キーが押されていれば
 * window.open を使う。プログラム的な遷移では e を渡さず navigate だけ行う。
 *
 * - 左クリック (button === 0) のみ新規タブ判定の対象とする。
 * - macOS では control + クリックはコンテキストメニュー扱いのため cmd (metaKey) のみ有効化し、
 *   ctrlKey は無視する。
 * - 親要素で既に preventDefault されている場合は何もしない。
 *
 * @returns 新規タブを開いた場合は true、それ以外 (同一タブ遷移 / 何もしない) は false
 */
export const openOrNavigate = (
  navigate: NavigateFunction,
  to: string,
  e?: MouseEvent,
  options?: NavigateOptions,
): boolean => {
  if (e === undefined) {
    void navigate(to, options)
    return false
  }

  if (e.defaultPrevented) {
    return false
  }

  const isMac =
    typeof navigator !== 'undefined' &&
    /Mac|iPod|iPhone|iPad/.test(navigator.platform)
  const shouldOpenNewTab =
    e.button === 0 && (e.metaKey || (!isMac && e.ctrlKey))

  if (shouldOpenNewTab) {
    e.preventDefault()
    window.open(to, '_blank')
    return true
  }

  void navigate(to, options)
  return false
}
